<template>
  <v-container>
    <v-btn style="float:right" @click="signout">
    </v-btn>
  </v-container>
</template>
<script>
import axios from 'axios'
  export default {
    name: "DashboardCoreLogout",

    data: () => ({
      links: [
        {
          href: '#',
          text: 'Creative Tim',
        },
      ],
    }),
    mounted(){
      this.signout()
    },
    methods: {
      signout: function() {
        var view = this
        try {
              let signout_url = view.$url('SIGNOUT_URL')
              axios.get(signout_url, {
                  headers: {
                    Authorization: this.$utils.getCookies('access_token'),
                    Userid : this.$utils.getCookies('user_id')
                  }
              }).then(res => {
                  if(res.data.statusCode == 200){
                      view.$utils.setCookies('isSignedIn', false,view)
                      view.$utils.removeCookies('access_token',view)
                      view.$utils.removeCookies('lastVisitedUrl',view)
                      view.$utils.removeCookies('email',view)
                      view.$utils.removeCookies('username',view)
                      view.$utils.removeCookies('user_id',view)
                      view.$utils.removeCookies('un_pass',view)
                      view.$utils.removeCookies('refresh_token',view)
                      view.$utils.removeCookies('portal_access',view)
                      view.$utils.removeCookies('token_expire_time',view)
                      view.$utils.removeCookies('startTime',view)
                      view.$utils.removeCookies('precedence_url',view)
                      view.$utils.removeCookies('user_role',view)
                      location.href = view.$url('SIGNIN_URL')
                  }
                }).catch((error) => {
                  console.error(error);
                });
            }catch(error){
              console.log('error signing out: ', error)
            }
      }
    },
  }
</script>

<style lang="sass">
  #dashboard-core-footer
    a
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase
</style>
<style scoped>
h1 {
    color: red;
}

h6{
    color: red;
    text-decoration: underline;
}

.main{
    position: absolute;
    width: 300px;
    height: 200px;
    z-index: 15;
    top: 50%;
    left: 50%;
    margin: -100px 0 0 -150px;
    /* background: red; */
}
</style>
